import { ChangeEvent, useCallback, useMemo, useState } from 'react'

import { LocationViewModel } from '@ail/locations-api'
import { useGetLocationsQuery } from '../../redux/api/locationsApi'
import { useAppSelector } from '../../redux/store'
import { IUserViewModel } from '../../types/interfaces'
import { TypeList } from './DriverModal'
import { useTranslation } from 'react-i18next'

interface Props {
  type: string
}
export function LocationSelect({ type }: Props) {
  const [inputValue, setInputValue] = useState('')
  const locations = useGetLocationsQuery({})
  const { t } = useTranslation('common')

  const user = useAppSelector((state) => state.appData.currentUser)
  const getRoleClass = (user?: IUserViewModel | null) => {
    if (!user) {
      return ''
    }
    switch (true) {
      case user.is4UPro:
        return 'URLGEN-4UPro'
      case user.isAdmin:
        return 'URLGEN-Admin'
      case user.isManager:
        return 'URLGEN-Manager'
      case user.isGuest:
        return 'URLGEN-Guest'
      case user.isSupplier:
        return 'URLGEN-Supplier'
      case user.isInternalUser:
        return 'URLGEN-Internal'
      default:
        return 'URLGEN-GenericCustomer'
    }
  }
  const updateLocationAndNavigate = useCallback(
    (location?: LocationViewModel, skip?: boolean) => {
      let url = `https://driver.interfleet.ch/location?partnerType=${type}`

      if (!skip && location) {
        const extraMenu = type === TypeList.smr || type === TypeList.neuwagen || type === TypeList.fuel
        const town = location.town.split(' ').join('+')
        if (!extraMenu) {
          url = `https://driver.interfleet.ch/partnerList?partnerType=${type}`
        }
        url += `&latitude=${location.latitude}&longitude=${location.longitude}&locationName=${location.postcode}+-+${town}&canton=${location.canton?.code}&searchType=SearchString`
      }
      window._mtm.push({ event: getRoleClass(user), value: getRoleClass(user) })
      window.open(url, '_blank')
    },
    [type, user]
  )

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    setInputValue(value)
  }

  const searchLocation = useMemo(() => {
    if (inputValue.length >= 2) {
      const searchResult = locations.data?.filter((location: LocationViewModel) => {
        return location.town.toLowerCase().includes(inputValue.toLowerCase()) || location.postcode.includes(inputValue)
      })
      if (searchResult && searchResult.length > 0 && searchResult !== undefined) {
        return searchResult
      } else {
        return []
      }
    }
  }, [inputValue, locations.data])

  const getResultsList = useCallback(() => {
    return searchLocation && searchLocation.length > 0 ? (
      <>
        {searchLocation
          .sort((a, b) => a.town.localeCompare(b.town))
          .map((location, index) => {
            if (index < 10) {
              return (
                <div
                  key={location.latitude}
                  onClick={() => updateLocationAndNavigate(location)}
                  className="autocomplete-result"
                >
                  <div className="resultCont">
                    <div className="resultName">
                      <img
                        className="kantons"
                        src={`../../../../kantons/${location.canton?.code}.svg`}
                        alt={`${location.canton?.code}`}
                        width={12}
                        height={14}
                      />
                      <span>
                        {location.postcode} - {location.town}
                      </span>
                    </div>
                  </div>
                  <i className="icon-right"></i>
                </div>
              )
            }
          })}
        {searchLocation.length > 9 && (
          <div className="resultCont">
            <div className="resultName">
              <span>{t('TOO_MANY_RESULTS')}</span>
            </div>
          </div>
        )}
      </>
    ) : (
      <div className="autocomplete-result">{t('NO_RESULTS_FOUND')}</div>
    )
  }, [searchLocation, t, updateLocationAndNavigate])

  return (
    <>
      <li className="list-item" onClick={() => updateLocationAndNavigate(undefined, true)}>
        <span>
          <i className="icon-location icon"></i>
          {t('DRIVER_CURRENT_LOCATION')}
        </span>
        <i className="icon-right"></i>
      </li>
      <li className="list-item">
        <i className="icon-locSrc icon"></i>
        <div className="searchArea">
          <input
            type="search"
            id="searchString"
            placeholder={t('DRIVER_INPUT_PLACEHOLDER')}
            autoComplete="off"
            value={inputValue}
            onChange={handleInputChange}
            onKeyDown={(event) =>
              event.key === 'Enter' && searchLocation && searchLocation?.length > 0
                ? updateLocationAndNavigate(searchLocation[0])
                : null
            }
          />
          <div
            className="autocomplete"
            id="autocomplete"
            style={{ display: inputValue.length >= 2 ? 'block' : 'none' }}
          >
            {getResultsList()}
          </div>
        </div>
        <i
          className="icon-search icon"
          id="searchByString"
          onClick={() =>
            searchLocation && searchLocation?.length > 0 ? updateLocationAndNavigate(searchLocation[0]) : null
          }
        ></i>
      </li>
    </>
  )
}
